/**
 * Types communs utilisés dans toute la feature analysis
 */

export enum RiskLevel {
  VERY_LOW = 0,
  LOW = 1,
  MEDIUM = 2,
  HIGH = 3,
}

export type DocumentType = 'pdf' | 'image';

export type AnalysisTabs =
  | 'preview'
  | 'anomaly'
  | 'mrz'
  | '2ddoc'
  | 'notes'
  | 'history';

export type DocumentLocation = 'left' | 'right';

export interface BaseResponse {}

export interface Coordinates {
  x: number;
  y: number;
  width: number;
  height: number;
}
